import React, { FocusEvent } from 'react';
import { FieldRenderProps } from 'react-final-form';
import WeddingLocationLookahead from './WeddingLocationLookahead';

const WeddingLocationLookaheadAdapter: React.FC<FieldRenderProps<string, HTMLElement>> = ({
  input,
  meta,
  inputOnFocus,
  containerClassname,
  ...rest
}) => {
  const hasError = meta && meta.touched && (meta.submitError || meta.error);
  const errorMessage = hasError ? meta.submitError || meta.error : '';
  const inputProps = {
    ...input,
    ...meta,
    onFocus: (event?: FocusEvent<HTMLElement>): void => {
      input.onFocus(event);
      if (inputOnFocus) inputOnFocus(event);
    },
    errorMessage,
    ...rest,
  };
  return <WeddingLocationLookahead inputProps={inputProps} className={containerClassname} />;
};

export default WeddingLocationLookaheadAdapter;



// WEBPACK FOOTER //
// ./src/pages/settings/wedding/WeddingDetails/components/WeddingLocationLookaheadAdapter/WeddingLocationLookaheadAdapter.tsx